export default __webpack_public_path__ + "static/media/sanmar1.c56accb1.jpg";